/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as KakaoRedirectImport } from './routes/kakao-redirect'
import { Route as authenticatedRouteImport } from './routes/(authenticated)/route'
import { Route as IndexImport } from './routes/index'
import { Route as SignKakaoRedirectImport } from './routes/sign/kakao-redirect'
import { Route as authenticatedDashboardImport } from './routes/(authenticated)/dashboard'
import { Route as authenticatedUsersIndexImport } from './routes/(authenticated)/users/index'
import { Route as authenticatedStatsIndexImport } from './routes/(authenticated)/stats/index'
import { Route as authenticatedPaymentIndexImport } from './routes/(authenticated)/payment/index'
import { Route as authenticatedKnowledgeBaseIndexImport } from './routes/(authenticated)/knowledge-base/index'
import { Route as authenticatedInviteIndexImport } from './routes/(authenticated)/invite/index'
import { Route as authenticatedUsersIdImport } from './routes/(authenticated)/users/$id'

// Create/Update Routes

const KakaoRedirectRoute = KakaoRedirectImport.update({
  id: '/kakao-redirect',
  path: '/kakao-redirect',
  getParentRoute: () => rootRoute,
} as any)

const authenticatedRouteRoute = authenticatedRouteImport.update({
  id: '/(authenticated)',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const SignKakaoRedirectRoute = SignKakaoRedirectImport.update({
  id: '/sign/kakao-redirect',
  path: '/sign/kakao-redirect',
  getParentRoute: () => rootRoute,
} as any)

const authenticatedDashboardRoute = authenticatedDashboardImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => authenticatedRouteRoute,
} as any)

const authenticatedUsersIndexRoute = authenticatedUsersIndexImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => authenticatedRouteRoute,
} as any)

const authenticatedStatsIndexRoute = authenticatedStatsIndexImport.update({
  id: '/stats/',
  path: '/stats/',
  getParentRoute: () => authenticatedRouteRoute,
} as any)

const authenticatedPaymentIndexRoute = authenticatedPaymentIndexImport.update({
  id: '/payment/',
  path: '/payment/',
  getParentRoute: () => authenticatedRouteRoute,
} as any)

const authenticatedKnowledgeBaseIndexRoute =
  authenticatedKnowledgeBaseIndexImport.update({
    id: '/knowledge-base/',
    path: '/knowledge-base/',
    getParentRoute: () => authenticatedRouteRoute,
  } as any)

const authenticatedInviteIndexRoute = authenticatedInviteIndexImport.update({
  id: '/invite/',
  path: '/invite/',
  getParentRoute: () => authenticatedRouteRoute,
} as any)

const authenticatedUsersIdRoute = authenticatedUsersIdImport.update({
  id: '/users/$id',
  path: '/users/$id',
  getParentRoute: () => authenticatedRouteRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/(authenticated)': {
      id: '/(authenticated)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof authenticatedRouteImport
      parentRoute: typeof rootRoute
    }
    '/kakao-redirect': {
      id: '/kakao-redirect'
      path: '/kakao-redirect'
      fullPath: '/kakao-redirect'
      preLoaderRoute: typeof KakaoRedirectImport
      parentRoute: typeof rootRoute
    }
    '/(authenticated)/dashboard': {
      id: '/(authenticated)/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof authenticatedDashboardImport
      parentRoute: typeof authenticatedRouteImport
    }
    '/sign/kakao-redirect': {
      id: '/sign/kakao-redirect'
      path: '/sign/kakao-redirect'
      fullPath: '/sign/kakao-redirect'
      preLoaderRoute: typeof SignKakaoRedirectImport
      parentRoute: typeof rootRoute
    }
    '/(authenticated)/users/$id': {
      id: '/(authenticated)/users/$id'
      path: '/users/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof authenticatedUsersIdImport
      parentRoute: typeof authenticatedRouteImport
    }
    '/(authenticated)/invite/': {
      id: '/(authenticated)/invite/'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof authenticatedInviteIndexImport
      parentRoute: typeof authenticatedRouteImport
    }
    '/(authenticated)/knowledge-base/': {
      id: '/(authenticated)/knowledge-base/'
      path: '/knowledge-base'
      fullPath: '/knowledge-base'
      preLoaderRoute: typeof authenticatedKnowledgeBaseIndexImport
      parentRoute: typeof authenticatedRouteImport
    }
    '/(authenticated)/payment/': {
      id: '/(authenticated)/payment/'
      path: '/payment'
      fullPath: '/payment'
      preLoaderRoute: typeof authenticatedPaymentIndexImport
      parentRoute: typeof authenticatedRouteImport
    }
    '/(authenticated)/stats/': {
      id: '/(authenticated)/stats/'
      path: '/stats'
      fullPath: '/stats'
      preLoaderRoute: typeof authenticatedStatsIndexImport
      parentRoute: typeof authenticatedRouteImport
    }
    '/(authenticated)/users/': {
      id: '/(authenticated)/users/'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof authenticatedUsersIndexImport
      parentRoute: typeof authenticatedRouteImport
    }
  }
}

// Create and export the route tree

interface authenticatedRouteRouteChildren {
  authenticatedDashboardRoute: typeof authenticatedDashboardRoute
  authenticatedUsersIdRoute: typeof authenticatedUsersIdRoute
  authenticatedInviteIndexRoute: typeof authenticatedInviteIndexRoute
  authenticatedKnowledgeBaseIndexRoute: typeof authenticatedKnowledgeBaseIndexRoute
  authenticatedPaymentIndexRoute: typeof authenticatedPaymentIndexRoute
  authenticatedStatsIndexRoute: typeof authenticatedStatsIndexRoute
  authenticatedUsersIndexRoute: typeof authenticatedUsersIndexRoute
}

const authenticatedRouteRouteChildren: authenticatedRouteRouteChildren = {
  authenticatedDashboardRoute: authenticatedDashboardRoute,
  authenticatedUsersIdRoute: authenticatedUsersIdRoute,
  authenticatedInviteIndexRoute: authenticatedInviteIndexRoute,
  authenticatedKnowledgeBaseIndexRoute: authenticatedKnowledgeBaseIndexRoute,
  authenticatedPaymentIndexRoute: authenticatedPaymentIndexRoute,
  authenticatedStatsIndexRoute: authenticatedStatsIndexRoute,
  authenticatedUsersIndexRoute: authenticatedUsersIndexRoute,
}

const authenticatedRouteRouteWithChildren =
  authenticatedRouteRoute._addFileChildren(authenticatedRouteRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof authenticatedRouteRouteWithChildren
  '/kakao-redirect': typeof KakaoRedirectRoute
  '/dashboard': typeof authenticatedDashboardRoute
  '/sign/kakao-redirect': typeof SignKakaoRedirectRoute
  '/users/$id': typeof authenticatedUsersIdRoute
  '/invite': typeof authenticatedInviteIndexRoute
  '/knowledge-base': typeof authenticatedKnowledgeBaseIndexRoute
  '/payment': typeof authenticatedPaymentIndexRoute
  '/stats': typeof authenticatedStatsIndexRoute
  '/users': typeof authenticatedUsersIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof authenticatedRouteRouteWithChildren
  '/kakao-redirect': typeof KakaoRedirectRoute
  '/dashboard': typeof authenticatedDashboardRoute
  '/sign/kakao-redirect': typeof SignKakaoRedirectRoute
  '/users/$id': typeof authenticatedUsersIdRoute
  '/invite': typeof authenticatedInviteIndexRoute
  '/knowledge-base': typeof authenticatedKnowledgeBaseIndexRoute
  '/payment': typeof authenticatedPaymentIndexRoute
  '/stats': typeof authenticatedStatsIndexRoute
  '/users': typeof authenticatedUsersIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/(authenticated)': typeof authenticatedRouteRouteWithChildren
  '/kakao-redirect': typeof KakaoRedirectRoute
  '/(authenticated)/dashboard': typeof authenticatedDashboardRoute
  '/sign/kakao-redirect': typeof SignKakaoRedirectRoute
  '/(authenticated)/users/$id': typeof authenticatedUsersIdRoute
  '/(authenticated)/invite/': typeof authenticatedInviteIndexRoute
  '/(authenticated)/knowledge-base/': typeof authenticatedKnowledgeBaseIndexRoute
  '/(authenticated)/payment/': typeof authenticatedPaymentIndexRoute
  '/(authenticated)/stats/': typeof authenticatedStatsIndexRoute
  '/(authenticated)/users/': typeof authenticatedUsersIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/kakao-redirect'
    | '/dashboard'
    | '/sign/kakao-redirect'
    | '/users/$id'
    | '/invite'
    | '/knowledge-base'
    | '/payment'
    | '/stats'
    | '/users'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/kakao-redirect'
    | '/dashboard'
    | '/sign/kakao-redirect'
    | '/users/$id'
    | '/invite'
    | '/knowledge-base'
    | '/payment'
    | '/stats'
    | '/users'
  id:
    | '__root__'
    | '/'
    | '/(authenticated)'
    | '/kakao-redirect'
    | '/(authenticated)/dashboard'
    | '/sign/kakao-redirect'
    | '/(authenticated)/users/$id'
    | '/(authenticated)/invite/'
    | '/(authenticated)/knowledge-base/'
    | '/(authenticated)/payment/'
    | '/(authenticated)/stats/'
    | '/(authenticated)/users/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  authenticatedRouteRoute: typeof authenticatedRouteRouteWithChildren
  KakaoRedirectRoute: typeof KakaoRedirectRoute
  SignKakaoRedirectRoute: typeof SignKakaoRedirectRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  authenticatedRouteRoute: authenticatedRouteRouteWithChildren,
  KakaoRedirectRoute: KakaoRedirectRoute,
  SignKakaoRedirectRoute: SignKakaoRedirectRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/(authenticated)",
        "/kakao-redirect",
        "/sign/kakao-redirect"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/(authenticated)": {
      "filePath": "(authenticated)/route.tsx",
      "children": [
        "/(authenticated)/dashboard",
        "/(authenticated)/users/$id",
        "/(authenticated)/invite/",
        "/(authenticated)/knowledge-base/",
        "/(authenticated)/payment/",
        "/(authenticated)/stats/",
        "/(authenticated)/users/"
      ]
    },
    "/kakao-redirect": {
      "filePath": "kakao-redirect.tsx"
    },
    "/(authenticated)/dashboard": {
      "filePath": "(authenticated)/dashboard.tsx",
      "parent": "/(authenticated)"
    },
    "/sign/kakao-redirect": {
      "filePath": "sign/kakao-redirect.tsx"
    },
    "/(authenticated)/users/$id": {
      "filePath": "(authenticated)/users/$id.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/invite/": {
      "filePath": "(authenticated)/invite/index.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/knowledge-base/": {
      "filePath": "(authenticated)/knowledge-base/index.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/payment/": {
      "filePath": "(authenticated)/payment/index.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/stats/": {
      "filePath": "(authenticated)/stats/index.tsx",
      "parent": "/(authenticated)"
    },
    "/(authenticated)/users/": {
      "filePath": "(authenticated)/users/index.tsx",
      "parent": "/(authenticated)"
    }
  }
}
ROUTE_MANIFEST_END */
